import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../Common';
import BulkProduct from '../../Common/BulkProduct';
import { getBulkProduct } from './bulkProductData';
import { SIZE_GUIDE_TITLE, SIZE_GUIDE_ITEMS } from '../Product/sizeGuideData';

/**
 * CLS-SE BulkProduct — thin brand wrapper.
 * Layout + logic live in `Clothing/Common/BulkProduct`.
 */
const CLSSEBulkProduct = () => {
  const { slug } = useParams();
  const product = getBulkProduct(slug);

  return (
    <BulkProduct
      product={product}
      brand="CLS"
      cartBrandSlug="clsse"
      priceSuffix=":-"
      Header={Header}
      labels={{
        sizeTitle: 'Välj storlek',
        sizeGuide: 'Storleksguide',
        infoTemplate: (n) => `Beställ minst ${n} st. av denna produkt.`,
        buttonLabel: 'Lägg i varukorg',
        minError: (n) => `Minst ${n} st. totalt`,
        notFound: 'Produkt hittades inte.',
        riskFree: {
          title: 'KÖP RISKFRITT',
          description: 'Beställ idag. Bestäm dig imorgon. Du har 24 timmar på dig att göra ändringar eller ångra ditt köp.',
        },
        delivery: {
          time: '3 veckor',
          cost: 'Gratis',
          description: 'Leverans till din skola',
        },
      }}
      sizeGuide={{ title: SIZE_GUIDE_TITLE, items: SIZE_GUIDE_ITEMS }}
    />
  );
};

export default CLSSEBulkProduct;
